import { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Author from './components/Author';
import Contact from './components/Contact';
import Tour from './components/Tour';
import TourSoCal from './components/TourSoCal';
import TourGeorgia from './components/TourGeorgia';
import TourStop from './components/TourStop';
import logo from './components/files/LWH TEXT LOGO.png';
import './App.css';

function MainSite() {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState(() => {
    return location.state?.section || 'home';
  });

  useEffect(() => {
    if (location.state?.section) {
      setActiveSection(location.state.section);
    }
  }, [location.state]);

  const skipTourIntro = location.state?.section === 'tour';

  const renderSection = () => {
    switch (activeSection) {
      case 'home':
        return <Hero key="home" />;
      case 'tour':
        return <Tour key="tour" skipIntro={skipTourIntro} />;
      case 'framework':
        return <About key="framework" />;
      case 'author':
        return <Author key="author" />;
      case 'contact':
        return <Contact key="contact" />;
      default:
        return <Hero key="home" />;
    }
  };

  return (
    <>
      <div className="top-logo">
        <img src={logo} alt="Love Works Here" />
      </div>
      <Navigation activeSection={activeSection} setActiveSection={setActiveSection} />
      <AnimatePresence mode="wait">
        {renderSection()}
      </AnimatePresence>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<MainSite />} />
        <Route path="/tour/west-coast" element={<TourSoCal />} />
        <Route path="/tour/east-coast" element={<TourGeorgia />} />
        <Route path="/tour/:stopId" element={<TourStop />} />
      </Routes>
    </div>
  );
}

export default App;
